export const LIMITED = 1;
export const UNLIMITED = -1;
/**
 * @deprecated Use BILLING_FREQUENCY_TO_BILLING_TYPE.QUARTERLY instead from wes-common
 */
export const QUARTERLY = 4;
/**
 * @deprecated Use BILLING_FREQUENCY_TO_BILLING_TYPE.ANNUALLY instead from wes-common
 */
export const ANNUALLY = 1;
